import React from 'react';

import type { TemperaturePreference } from '../utils/cartNormalization';

type BeverageTemperatureControlProps = {
  value: TemperaturePreference;
  onChange: (next: TemperaturePreference) => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
  coldDisabled?: boolean;
  ambientDisabled?: boolean;
};

const BeverageTemperatureControl: React.FC<BeverageTemperatureControlProps> = ({
  value,
  onChange,
  disabled = false,
  size = 'md',
  coldDisabled = false,
  ambientDisabled = false
}) => {
  const buttonClass =
    size === 'sm'
      ? 'px-1.5 py-0.5 text-[9px] rounded-md'
      : 'px-3 py-1.5 text-[10px] rounded-xl';

  return (
    <div
      className={`inline-flex items-center gap-0.5 border border-white/10 bg-black/30 ${
        size === 'sm' ? 'rounded-lg p-px' : 'rounded-xl p-0.5'
      }`}
      role="group"
      aria-label="Drink temperature preference"
    >
      {(['chilled', 'ambient'] as const).map((option) => {
        const selected = value === option;
        const isOptionDisabled =
          disabled ||
          (option === 'chilled' && coldDisabled) ||
          (option === 'ambient' && ambientDisabled);
        return (
          <button
            key={option}
            type="button"
            disabled={isOptionDisabled}
            aria-pressed={selected}
            onClick={() => onChange(option)}
            className={`${buttonClass} font-black uppercase tracking-widest transition-all disabled:opacity-40 disabled:cursor-not-allowed ${
              selected
                ? 'bg-ninpo-lime text-ninpo-black'
                : 'text-slate-400 hover:text-white hover:bg-white/5'
            }`}
          >
            {option === 'chilled'
              ? coldDisabled
                ? size === 'sm'
                  ? 'Chilled N/A'
                  : 'Chilled (N/A)'
                : '❄ Chilled'
              : ambientDisabled
                ? size === 'sm'
                  ? 'Ambient N/A'
                  : 'Ambient (N/A)'
                : '📦 Ambient'}
          </button>
        );
      })}
    </div>
  );
};

export default BeverageTemperatureControl;
